"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAxiosResponseValidation = void 0;
const withAxiosResponseValidation = function (callback, schema) {
  return async function () {
    const {
      data
    } = await callback(...arguments);
    return schema.parse(data);
  };
};
exports.withAxiosResponseValidation = withAxiosResponseValidation;